import { render } from "./EksdInitialTestResults2.vue?vue&type=template&id=3f52c71d"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__